module.exports = __webpack_public_path__ + "static/media/logo-velora-classic.db0d627a.svg";